import FadeOut from './fade_out';

export default FadeOut;
